import { RootState } from '../types'

export const getBonusesSelector = (state: RootState) => state.bonus.bonuses
